import { Icon } from 'ant-design-vue'

const UserIcon = Icon.createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/c/font_2149596_fbegiq0x3h.js', // 在 iconfont.cn 上生成
  extraCommonProps: {
    className: 'user-icon'
  }
})

export default {
  install: function (Vue) {
    Vue.use(Icon)
    Vue.component('user-icon', UserIcon)
  }
}
